var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "magic-zoom" } }, [
    _c(
      "div",
      { attrs: { itemscope: "", itemtype: "http://schema.org/Thing" } },
      [
        _c(
          "div",
          {
            staticClass: "ItemImgWrap justify-content-center",
            class: { "more-images": _vm.magiczoom.images.all.length > 1 },
          },
          [
            _c(
              "a",
              {
                staticClass:
                  "MagicZoomPlus flex-fill d-flex align-items-start justify-content-center",
                attrs: {
                  href: _vm._f("itemImage")(
                    _vm._f("itemImages")(_vm.magiczoom.images, "url")
                  ),
                  id: "ItemImgZoom",
                  "aria-label": "image zoom",
                  "data-mobile-options":
                    "zoomMode:off; lazyZoom: true; textTouchZoomHint:" +
                    _vm.$translate("Servershop5::Template.singleZoomHint") +
                    "; textClickZoomHint: " +
                    _vm.$translate("Servershop5::Template.singleZoomHint2") +
                    "; textExpandHint: " +
                    _vm.$translate("Servershop5::Template.singleZoomHint"),
                  "data-options":
                    "zoomMode: off; zoomOn: click; lazyZoom: true; textClickZoomHint: Klicken um zu vergrößern; " +
                    "cssClass: white-bg; ;" +
                    "textExpandHint:" +
                    _vm.$translate("Servershop5::Template.singleZoomHint3") +
                    "; zoomPosition: #zoom-placeholder;",
                },
              },
              [
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: {
                    alt: "middle size zoom image",
                    src: _vm._f("itemImage")(
                      _vm._f("itemImages")(_vm.magiczoom.images, "urlMiddle")
                    ),
                    itemprop: "image",
                  },
                }),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "text-muted small ml-5 mb-2" }, [
          _vm._v(
            _vm._s(_vm.$translate("Servershop5::Template.deliveryScopeHint"))
          ),
        ]),
        _vm._v(" "),
        _vm.magiczoom.images.all.length > 1
          ? [
              _vm.magiczoom.images.all.length > 3
                ? _c(
                    "div",
                    {
                      staticClass:
                        "magic-more-images position-relative d-flex mb-4",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "arrows left",
                          on: {
                            click: function ($event) {
                              return _vm.slidePrev()
                            },
                          },
                        },
                        [_c("i", { staticClass: "fa fa-angle-left" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "hooper",
                        {
                          ref: "carousel",
                          staticClass: "d-block flex-fill",
                          attrs: { settings: _vm.hoopersettings },
                        },
                        _vm._l(
                          _vm.magiczoom.images.all,
                          function (imagePreview, index) {
                            return _c("slide", [
                              _c(
                                "a",
                                {
                                  staticClass: "border",
                                  attrs: {
                                    href: _vm.magiczoom.images.all[index].url,
                                    rel: "zoom-id:ItemImgZoom",
                                    "data-image":
                                      _vm.magiczoom.images.all[index].urlMiddle,
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "img-fluid",
                                    attrs: {
                                      alt: "preview image zoom" + index,
                                      "data-src": imagePreview.url,
                                      src: imagePreview.urlPreview,
                                    },
                                  }),
                                ]
                              ),
                            ])
                          }
                        ),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "arrows right",
                          on: { click: _vm.slideNext },
                        },
                        [_c("i", { staticClass: "fa fa-angle-right" })]
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "magic-more-images d-none d-lg-flex mb-4" },
                    [
                      _vm._l(
                        _vm.magiczoom.images.all,
                        function (imagePreview, index) {
                          return [
                            _c(
                              "a",
                              {
                                staticClass: "mb-2 border maxWidthImages",
                                attrs: {
                                  href: _vm.magiczoom.images.all[index].url,
                                  rel: "zoom-id:ItemImgZoom",
                                  "data-image":
                                    _vm.magiczoom.images.all[index].urlMiddle,
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "img-fluid",
                                  attrs: {
                                    alt: "preview image zoom" + index,
                                    "data-src": imagePreview.url,
                                    src: imagePreview.urlPreview,
                                  },
                                }),
                              ]
                            ),
                          ]
                        }
                      ),
                    ],
                    2
                  ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "zoom-navigation-dots d-md-none" }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }